var _path, _path2, _path3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAddVideo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 18,
    viewBox: "0 0 27 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8311 0C18.7119 0 19.7314 1.06348 19.7314 2.90918V11.5576C19.7314 13.4033 18.6416 14.4668 16.7607 14.4668H9.93164C10.1689 13.8516 10.292 13.1748 10.292 12.4805C10.292 9.31641 7.69043 6.71484 4.52637 6.70605V2.90918C4.52637 1.06348 5.67773 0 7.49707 0H16.8311Z",
    fill: "black"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M21.0146 10.0371L24.0381 12.6475C24.3984 12.9551 24.7764 13.1484 25.1367 13.1484C25.8486 13.1484 26.332 12.6387 26.332 11.874V2.62793C26.332 1.86328 25.8486 1.35352 25.1367 1.35352C24.7764 1.35352 24.3984 1.54688 24.0381 1.86328L21.0146 4.46484V10.0371Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 12.5264C0 15.0049 2.04785 17.0527 4.52637 17.0527C6.9873 17.0527 9.05273 14.9961 9.05273 12.5264C9.05273 10.0479 7.00488 8 4.52637 8C2.04785 8 0 10.0479 0 12.5264ZM3.92871 14.7939C3.92871 15.1543 4.16602 15.3916 4.52637 15.3916C4.88672 15.3916 5.12402 15.1543 5.12402 14.7939V13.124H6.79395C7.14551 13.124 7.3916 12.8867 7.3916 12.5264C7.3916 12.166 7.14551 11.9287 6.79395 11.9287H5.12402V10.2588C5.12402 9.90723 4.88672 9.66113 4.52637 9.66113C4.16602 9.66113 3.92871 9.90723 3.92871 10.2588V11.9287H2.25879C1.89844 11.9287 1.66113 12.166 1.66113 12.5264C1.66113 12.8867 1.90723 13.124 2.25879 13.124H3.92871V14.7939Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAddVideo);
export default __webpack_public_path__ + "static/media/add-video.ff313058297974b3981d9b1b81d03996.svg";
export { ForwardRef as ReactComponent };